const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  readingIdKey: 'reading_id',
  chapterNameKay: 'chapterName',
  totalReadingKey: 'TotalReading',
  freeQuestionsCountKey: 'TotalFreeQuestions',
  premiumQuestionsCountKey: 'TotalQuestions',
  questionTableKey: 'questions_frm',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/ApiAttributesKays.js